module.exports = __webpack_public_path__ + "img/4L.3296be0b.png";